import * as React from "react";
import useProductName from "brand-customization/useProductName";
const GroupSearchPattern = () => {
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement("span", null, "The search pattern used to find groups in LDAP for mapping to ", productName, " teams, e.g", " ", /* @__PURE__ */ React.createElement("code", { className: "text-nowrap", key: "group-search-pattern-example-1" }, "(objectClass=group)"));
};
const TeamNameAttribute = () => {
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement("span", null, "Which LDAP attribute to use for the full name of the ", productName, " team, usually", " ", /* @__PURE__ */ React.createElement("code", { key: "team-name-attribute-example" }, "cn"), ".");
};
const TeamUniqueIdAttribute = () => {
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement("span", null, "Which LDAP attribute to use for the uniq ID attribute of the ", productName, " team, e.g.", " ", /* @__PURE__ */ React.createElement("code", { key: "team-unique-id-attribute" }, "entryUUID"), ".");
};
const help = {
  groupSearchBase: /* @__PURE__ */ React.createElement("span", null, "The base tree to limit the LDAP group search query to, e.g.", " ", /* @__PURE__ */ React.createElement("code", { key: "group-search-base-example" }, "ou=people,dc=example,dc=com"), "."),
  groupSearchPattern: /* @__PURE__ */ React.createElement(GroupSearchPattern, null),
  teamUniqueIdAttribute: /* @__PURE__ */ React.createElement(TeamUniqueIdAttribute, null),
  teamNameAttribute: /* @__PURE__ */ React.createElement(TeamNameAttribute, null),
  teamDefaultRoles: "The default roles synchronized teams will obtain. All users of a team will inherit these roles."
};
const initialValues = {
  teamUniqueIdAttribute: "entryUUID",
  teamNameAttribute: "cn"
};
export default { help, initialValues };
